module.exports = __webpack_public_path__ + "static/media/Purchase_Succeeded@3x.6b19312c.png";